<template>
    <div class="d-flex flex-column" style="width: 100%;">
        <!-- Header Section -->
        <div class="px-8 py-6 white mb-4 rounded-xl elevation-1 d-flex align-center">
            <v-avatar color="teal lighten-5" size="48" class="mr-4">
                <v-icon color="teal darken-2">mdi-heart-plus-outline</v-icon>
            </v-avatar>
            <div>
                <h2 class="text-h6 font-weight-bold teal--text text--darken-4 mb-0">CHẾ ĐỘ & HỢP ĐỒNG</h2>
                <p class="text-caption grey--text text--darken-1 mb-0">Danh sách mã chế độ và hợp đồng làm việc</p>
            </div>
        </div>

        <!-- Bảng Danh sách hợp đồng -->
        <v-card class="rounded-xl mx-auto mb-6 pt-2" flat style="width: 100%; border: 1px solid #e0f2f1;">
            <v-card-title class="text-subtitle-1 font-weight-bold teal--text text--darken-4 px-8" style="text-transform: uppercase;">
                <v-avatar size="28" class="rounded-lg mr-3" color="teal lighten-5">
                    <v-icon size="18px" color="teal darken-3">mdi-file-document-edit-outline</v-icon>
                </v-avatar> DANH SÁCH HỢP ĐỒNG
            </v-card-title>
            <v-card-text class="px-8 mt-2">
                <v-data-table :items="contracts" :headers="contractHeaders" :loading="loadingContracts">
                     <template v-slot:[`item.signDate`]="{ item }">
                        {{ formatDate(item.signDate, "DD/MM/YYYY") }}
                    </template>
                    <template v-slot:[`item.expireDate`]="{ item }">
                        {{ formatDate(item.expireDate, "DD/MM/YYYY") }}
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <!-- Bảng Chế độ phúc lợi -->
        <v-card class="rounded-xl mx-auto mb-6 pt-2" flat style="width: 100%; border: 1px solid #e0f2f1;">
            <v-card-title class="text-subtitle-1 font-weight-bold teal--text text--darken-4 px-8" style="text-transform: uppercase;">
                <v-avatar size="28" class="rounded-lg mr-3" color="teal lighten-5">
                    <v-icon size="18px" color="teal darken-3">mdi-gift-outline</v-icon>
                </v-avatar> CHẾ ĐỘ PHÚC LỢI
            </v-card-title>
            <v-card-text class="px-8 mt-2">
                <v-data-table :items="benefitMans" :headers="benefitManHeaders" :items-per-page="-1">
                    <template v-slot:[`item.type`]="{ item }">
                        {{item.type == "TC" ? "Tang chế" : (item.type == "HH" ? "Hỷ sự": (item.type == "KT"? "Khám thai": (item.type == "OFF"? "Nghỉ có lương": (item.type == "OM"? "Phép ốm": (item.type == "CON"? "Con nhỏ": (item.type == "PT"? "Phép tháng (ngoại lệ)": "Khác")))))) }}
                    </template>
                    <template v-slot:[`item.from`]="{ item }">
                        {{ formatDate(item.from, "DD/MM/YYYY")}}
                    </template>
                    <template v-slot:[`item.to`]="{ item }">
                        {{ formatDate(item.to, "DD/MM/YYYY")}}
                    </template>
                    <template v-slot:[`item.createdAt`]="{ item }">
                        {{ formatDate(item.createdAt, "DD/MM/YYYY HH:mm:ss")}}
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import moment from 'moment/moment';

export default {
    name: 'TabBenefit',
    props: {
        benefitMans: Array,
        benefitManHeaders: Array,
        employeeCode: String
    },
    data() {
        return {
            loadingContracts: false,
            contracts: [],
            contractHeaders: [
                { text: 'Mã', value: 'code', width: 100},
                { text: 'Phân loại', value: 'contractCategoryName', width: 120},
                { text: 'Loại hợp đồng', value: 'contractType', width: 120},
                { text: 'Ngày kí', value: 'signDate', width: 120},
                { text: 'Ngày hết hạn', value: 'expireDate', width: '7rem'},
                // { text: 'Lương thỏa thuận', value: 'salary', width: 180},
                { text: 'Thời hạn', value: 'length', width: 100},
                { text: 'Đơn vị', value: 'lengthUnit', width: 150},
            ]
        }
    },
    watch: {
        employeeCode: {
            handler(newVal) {
                if (newVal) this.fetchContracts();
            },
            immediate: true
        }
    },
    methods: {
        formatDate(val, format) {
            if (!val) return '';
            return moment(val).format(format);
        },
        fetchContracts() {
            this.loadingContracts = true;
            return http.get("employees/contract-history/" + this.employeeCode).then(res => {
                this.contracts = res.data;
                console.log('contracts', res.data)
            }).finally(() => {
                this.loadingContracts = false;
            });
        }
    }
}
</script>
